// // @flow
import React from 'react';

const StructuredDataFooter = () => {
  const [structuredData, setStructuredData] = React.useState(null);

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    // Safe extraction of metadata with fallback values
    const pageData = {
      url: window.location.href,
      title: document.title || 'Ansarada',
      datePublished:
        document
          .querySelector("meta[property='article:published_time']")
          ?.getAttribute('content') || new Date().toISOString(),
      dateModified:
        document.querySelector("meta[property='article:modified_time']")?.getAttribute('content') ||
        new Date().toISOString(),
      description:
        document.querySelector("meta[name='description']")?.getAttribute('content') ||
        'No description available.',
      language: document.documentElement?.lang || 'en-AU', // Default to en-AU if not set
    };

    const structuredDataObject = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': pageData.url,
          url: pageData.url,
          name: pageData.title,
          isPartOf: {
            '@id': 'https://www.ansarada.com',
          },
          datePublished: pageData.datePublished,
          dateModified: pageData.dateModified,
          description: pageData.description,
          inLanguage: pageData.language,
        },
        {
          '@type': 'WebSite',
          '@id': 'https://www.ansarada.com',
          url: 'https://www.ansarada.com',
          name: 'Ansarada',
          description: 'AI-Powered Virtual Data Rooms & Dealmaking Tools',
          inLanguage: 'en-AU',
        },
      ],
    };

    setStructuredData(structuredDataObject);
  }, []);

  if (!structuredData) return null;

  return <script type="application/ld+json">{JSON.stringify(structuredData)}</script>;
};

export default StructuredDataFooter;
